export default "__VITE_ASSET__7048IcaNRvii_PAUGBo6zw__"